import { Input } from "@angular/core";
import { BaseFilterCellComponent, ColumnComponent } from "@progress/kendo-angular-grid";
import { CompositeFilterDescriptor } from "@progress/kendo-data-query";
import { Options } from '../../../classes/column';

export abstract class CustomFilterCell extends BaseFilterCellComponent {

    @Input() public filter: CompositeFilterDescriptor;

    @Input() public column: ColumnComponent;

    @Input() public options: Options;

    /**
     * The properties that need to be
     */
    public inputs: Array<string> = [];

    /**
     * Indicates whether or not there is a filter active
     *
     * @return {boolean}
     */
    public get hasFilter(): boolean {
        return this.filtersByField(this.column.field).length > 0;
    }

    /**
     * Clears the filter
     *
     * @return {void}
     */
    public clearFilter(): void {
        this.filterService.filter(
            this.removeFilter(this.column.field)
        );
    }
}



// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/components/filters/classes/custom-filter-cell.ts